import { render, staticRenderFns } from "./UserGroupFilters.vue?vue&type=template&id=5423a7d6&scoped=true"
import script from "./UserGroupFilters.vue?vue&type=script&lang=js"
export * from "./UserGroupFilters.vue?vue&type=script&lang=js"
import style0 from "./UserGroupFilters.vue?vue&type=style&index=0&id=5423a7d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5423a7d6",
  null
  
)

export default component.exports